<template>
    <span>
        <b-form-radio
            v-model="value"
            :value="option"
            :name="name"
            plain
            @change="onChange"
        ></b-form-radio>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                value: false,
            };
        },
        created() {
            this.value = this.params.value;
            this.option = this.params.radioOption && this.params.radioOption(this.params);
            this.name = this.params.radioName || '';
        },
        methods: {
            onChange(value) {
                const newValue = value;
                const oldValue = this.value;
                this.value = newValue;
                if (this.params.onChange) {
                    this.params.onChange(this.params, newValue);
                }
            }
        }
    }
</script>
